import styled, { FlattenSimpleInterpolation } from 'styled-components'

type Props = {
    color?: string
    /** Number in pixel @default 14 */
    size?: number
    custom?: FlattenSimpleInterpolation
}

/**
 *  @prop color `var(--gray-800)`
 *  @default size '14px'
 */
export const Icon = styled.i<Props>`
    font-size: ${({ size = 14 }) => size}px !important;
    color: ${({ color }) => color} !important;

    ${({ custom }) => custom}
`

export default Icon
